export default "__VITE_ASSET__vxeKZsOe__"